var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99713 0.840027C4.0173 0.840027 3.03921 1.15037 2.38605 1.88076C1.43922 2.93955 0.732998 4.22139 0.354265 5.63866C0.245229 6.04669 0.566803 6.42864 0.98915 6.42864V6.42864C1.36463 6.42864 1.66903 6.73303 1.66903 7.10851V8.74812C1.66903 9.13622 1.3544 9.45085 0.966299 9.45085V9.45085C0.535855 9.45085 0.204807 9.83532 0.30736 10.2534C0.666989 11.7194 1.37533 13.0467 2.33854 14.1408C3.0166 14.911 4.0425 15.235 5.06863 15.235H13.2551C14.2812 15.235 15.3071 14.911 15.9852 14.1408C16.9484 13.0467 17.6567 11.7193 18.0164 10.2533C18.1189 9.8353 17.7879 9.45085 17.3575 9.45085V9.45085C16.9694 9.45085 16.6548 9.13624 16.6548 8.74815V7.10848C16.6548 6.73302 16.9591 6.42864 17.3346 6.42864V6.42864C17.7569 6.42864 18.0785 6.0467 17.9695 5.63869C17.5907 4.22141 16.8845 2.93956 15.9377 1.88076C15.2845 1.15037 14.3064 0.840027 13.3266 0.840027H4.99713Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.35339,
    y: 16.1666,
    width: 1.61333,
    height: 2.42,
    rx: 0.476667,
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellIcon);
export default __webpack_public_path__ + "static/media/CellIcon.61cdd533f7bf54a04c1babf280cf4533.svg";
export { ForwardRef as ReactComponent };